import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth/services/auth.service';
import { take } from 'rxjs';
import { EventBusService } from './shared/event-bus/event-bus.service';
import { provideContacts } from './user';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'at-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: provideContacts(),
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'layout-grid full',
  },
})
export class AppComponent {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly authService = inject(AuthService);
  private readonly eventBusService = inject(EventBusService);

  constructor() {
    this.eventBusService.on('logout', () => this.#logout());

    this.eventBusService.on('loggedOut', (reload) => {
      if (typeof reload === 'boolean' && reload === false) return;

      this.#loggedOut();
    });
  }

  #logout() {
    this.authService.logout().pipe(take(1)).subscribe();
  }

  #loggedOut() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.reload();
    }
  }
}
